import { CSSProperties, ReactElement, SyntheticEvent } from 'react'
import DynamicSVG from '../DynamicSVG/DynamicSVG'
import "../TodosPage/TodosPage.css"
import TodoHandler from '../../Database/handlers/TodoHandler'
import ScheduleHandler from '../../Database/handlers/ScheduleHandler'
import { useEffect,useState } from 'react'
import ConvertToTodosList from '../../Utilities/ConvertToTodosList'
import FetchAndSortTodos from '../../Utilities/FetchAndSortTodos'
import { ITodo, ITodoLists } from '../../types/interfaces'
import Toastlist from '../ToastsList/ToastsList'
import useToast from '../../hooks/useToast'
import Drawer from '../Drawer/Drawer'
import useDrawer from '../../hooks/useDrawer'
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd"
import TodoListItem from './TodoListItem/TodoListItem'
import TopNavBar from '../TopNavBar/TopNavBar'
import useLocalStorage from '../../hooks/useLocalStorage'
export default function TodosPage() {
  const [isDrawerOpen, toggleDrawerModal] = useDrawer()
  const [project,setProject] =useLocalStorage("project",null)
  const [Toasts,setToast,DeleteToast] = useToast()
  const [State, setState] = useState<{
    // PendingTodosArr: ReactElement[],
    // OngoingTodosArr:ReactElement[],
    // CompletedTodosArr: ReactElement[],
    // TodosList: ITodo[],
    
    TodosData:ITodoLists
  }>
    ({
    // PendingTodosArr: [],
    // OngoingTodosArr: [],
    // CompletedTodosArr: [],
    // TodosList:[],
      TodosData: {
        todos: [],
        columnOrder: ["Pending", "Ongoing", "Completed"],
        columns: {
          "Pending":{id:"Pending",title:"Pending",taskIDs:[]},
          "Ongoing":{id:"Ongoing",title:"Ongoing",taskIDs:[]},
          "Completed":{id:"Completed",title:"Completed",taskIDs:[]}
        }
      },
   
  })
  const listItemCallBacksObj = {
    handleDeleteTodo, handleUpdateTodo, handleModal: toggleDrawerModal,handleEditTodo
  }
  const todoHandler = new TodoHandler()
  const schedulehandler = new ScheduleHandler()
  
  function CreateTodo(event:SyntheticEvent) {
    event.preventDefault()
    const form = event.target as HTMLFormElement
    const target = event.target as typeof event.target & {
      title: { value: string };
      description: { value: string };
      priority: { value: string };
    }
    const formObj = {
      title:target.title.value,
      description: target.description.value,
      priority: target.priority.value,
      
    }
    todoHandler.CreateTodo(
      formObj.title, formObj.description,
      formObj.priority, State.TodosData.columns["Pending"].taskIDs.length,
      project?.ProjectName)
    form.reset()
    toggleDrawerModal()
  }
  
  async function handleUpdateTodo(filterKeyString:number,toStatus:"Pending"|"Ongoing"|"Completed") {
    // await todoHandler.UpdateTodoItem(filterKeyString)
    console.log(filterKeyString,toStatus)
    await todoHandler.UpdateTodoStatus(filterKeyString,toStatus)
    const list = await FetchAndSortTodos(project.ProjectName)
    setState({
      TodosData:list,
      
    })
    // const TodosArr = ConvertToTodosList(
    //   listItemCallBacksObj,
    //   list.todos
    // )
    // setState({
    //   PendingTodosArr:TodosArr[0],
    //   OngoingTodosArr:TodosArr[1],
    //   CompletedTodosArr: TodosArr[2],
    //   TodosList: TodosArr[3],
    //   ProgressBarVal:TodosArr[2].length*(100/TodosArr[3].length) || 0
    // })
    
  }
  async function handleEditTodo(updateDataObj:ITodo) {
    await todoHandler.EditTodoItem(
      updateDataObj.id?updateDataObj.id:0,
      updateDataObj.title,
      updateDataObj.description, updateDataObj.priority)
    const list = await FetchAndSortTodos(project.ProjectName)
    setState({
      TodosData:list,
     
    })
    // const TodosArr = ConvertToTodosList(
    //   listItemCallBacksObj,
    //   list.PendingTodos, list?.OngoingTodos, list?.CompletedTodos,list.TodosList
    // )
    // setState({
    //   PendingTodosArr:TodosArr[0],
    //   OngoingTodosArr:TodosArr[1],
    //   CompletedTodosArr: TodosArr[2],
    //   TodosList: TodosArr[3],
    //   ProgressBarVal:TodosArr[2].length*(100/TodosArr[3].length) || 0
    // })
  }
  async function handleDeleteTodo(filterKeyString:number) {
    await todoHandler.DeleteTodoItem(filterKeyString)
    const list = await FetchAndSortTodos(project.ProjectName)
    setState({
      TodosData:list,
     
    })
    // const TodosArr = ConvertToTodosList(
    //   listItemCallBacksObj,
    //   list.PendingTodos,list?.OngoingTodos,list?.CompletedTodos,list.TodosList
    // )
    // setState({
    //   PendingTodosArr:TodosArr[0],
    //   OngoingTodosArr:TodosArr[1],
    //   CompletedTodosArr: TodosArr[2],
    //   TodosList: TodosArr[3],
    //   ProgressBarVal:TodosArr[2].length*(100/TodosArr[3].length) || 0
    // })
  }
  useEffect(() => {
    todoHandler.FindMatchingSchedules(new Date(),project.ProjectName).then((data) => {
      todoHandler.CreateMultipleTodos(data.todosArr).then(() => {
        console.log("done done")
        FetchAndSortTodos(project.ProjectName,[
        State.TodosData.columns["Pending"].taskIDs,
        State.TodosData.columns["Ongoing"].taskIDs,
        State.TodosData.columns["Completed"].taskIDs
      ]).then((list) => {
        console.log("this is todos :", data.todosArr,list)
        
        
        data.scheduleKeysArr.forEach((key) => {
          console.log(key)
          schedulehandler.DeleteSchedule(key)
        })
        if (data.scheduleNamesArr.length > 0) {
          console.log(data)
          setToast(1,"New Schedules Added",`${data.scheduleNamesArr.toString()}`,DeleteToast)
          // CreateNotif("New Schedules Added", { body: `${data.scheduleNamesArr.toString()}` })
        }

        setState({
          TodosData:list,
        })
        // const TodosArr = ConvertToTodosList(
        //   listItemCallBacksObj,
        //   [...data.todosArr, ...list?.PendingTodos],
        //   list?.OngoingTodos, list?.CompletedTodos,
        //   [...data.todosArr, ...list?.TodosList]
        // ) 
        // console.log(TodosArr[3])
        // setState({
        //   PendingTodosArr:TodosArr[0],
        //   OngoingTodosArr:TodosArr[1],
        //   CompletedTodosArr: TodosArr[2],
        //   TodosList: TodosArr[3],
        //   ProgressBarVal:TodosArr[2].length*(100/TodosArr[3].length) || 0
        // })
      
      })
      })
      
        
    })

  }, [isDrawerOpen])
  
  function onDragEnd(result:any) {
    console.log(result)
    const { destination, source, draggableId } = result
    
    if (!destination) return
    if (destination.droppableId == source.droppableId
      && destination.index == source.index) return
    
    const todos = State.TodosData.todos
    let resultTodoIndex = 0
    let resultTodo = State.TodosData.todos.filter((todo, i) => {
      if (todo.id == draggableId ) resultTodoIndex = i
      return todo.id == draggableId
    })[0]
    
    console.log(resultTodo, destination.droppableId)
    
    const droppedColName:"Pending" | "Ongoing" | "Completed"=destination.droppableId
    const todoStatus = resultTodo.status
    const toStatus = droppedColName
    let UpdateObj = {}
    let startDate, endDate;
    
    
    if (todoStatus == "Pending" && toStatus == "Ongoing") {
      
      startDate = new Date()
      UpdateObj = {status:toStatus,startDate}
    } else if (todoStatus == "Ongoing" && toStatus == "Completed") {
      
      startDate = resultTodo.startDate
      endDate = new Date()
      UpdateObj = {status:toStatus,startDate,endDate}
    } else if (todoStatus == "Completed" && toStatus == "Ongoing") {
      
      startDate = new Date()
      UpdateObj = {status:toStatus,startDate}
    } else if (todoStatus == "Ongoing" && toStatus == "Pending") {
      
      startDate = new Date()
      UpdateObj = {status:toStatus,startDate}
    } else if (todoStatus == "Completed" && toStatus == "Pending") {
      
      UpdateObj = {status:toStatus}
    }else if (todoStatus == "Pending" && toStatus == "Completed") {
      
      startDate = new Date()
      endDate = new Date()
      UpdateObj = {status:toStatus,startDate,endDate}
    }

    resultTodo = { ...resultTodo, ...UpdateObj }
    todos.splice(resultTodoIndex,1,resultTodo)

    
    
    const startColumn = State.TodosData.columns[source.droppableId]
    const finishColumn = State.TodosData.columns[destination.droppableId]
    if (startColumn == finishColumn) {
      const taskIds = Array.from(startColumn.taskIDs)
      taskIds.splice(source.index, 1)
      taskIds.splice(destination.index, 0, draggableId)
      
      const newColumn = {
        ...startColumn,taskIDs:taskIds
      }
      // setState({ ...State, columns: { ...State.columns, [newColumn.id]: newColumn } })
      setState({
        ...State, TodosData:
        {
          ...State.TodosData, todos: todos, columns:
            { ...State.TodosData.columns, [newColumn.id]: newColumn }
        }
      })
      
      return
    } else {
      const startTaskIDs = Array.from(startColumn.taskIDs)
    startTaskIDs.splice(source.index, 1)
    const newStartColumn = { ...startColumn, taskIDs: startTaskIDs }
    
    const finishTaskIDs = Array.from(finishColumn.taskIDs)
    finishTaskIDs.splice(destination.index, 0,draggableId)
    const newFinishColumn = { ...finishColumn, taskIDs: finishTaskIDs }
    
    setState({
      ...State, TodosData: {
        ...State.TodosData,todos:todos,
        columns: {
          ...State.TodosData.columns,
          [newStartColumn.id]: newStartColumn,[newFinishColumn.id]:newFinishColumn
        }
        
      }
    })
    
    console.log(State.TodosData.columns)
    todoHandler.UpdateTodoStatus(resultTodo.id || 0, droppedColName).then(() => {
      FetchAndSortTodos(project.ProjectName,[
        State.TodosData.columns["Pending"].taskIDs,
        State.TodosData.columns["Ongoing"].taskIDs,
        State.TodosData.columns["Completed"].taskIDs
      ]).then((todosData) => {
        setState({
        ...State, TodosData: {
          ...State.TodosData,
          todos:todosData.todos,
          columns: {
            ...State.TodosData.columns,
            [newStartColumn.id]: newStartColumn,[newFinishColumn.id]:newFinishColumn
          }
          
        }
      })
      })
      
    })
    }
    

    
  }
  return (
    <>
      <Toastlist autoDelete={true} autoDeleteTime={5000} toastsArr={Toasts} deleteToast={DeleteToast}/>
      <Drawer isOpen={isDrawerOpen} toggleDrawer={toggleDrawerModal}>
        <div>
          <h2 className='Drawer-Title'>Create a brand new todo :</h2>
          <form id='Todo-Form' onSubmit={CreateTodo}>
            <div className='Input-Container'>
              <label htmlFor='Title-Input'>Title :</label>
              <input name='title'  id='Title-Input' required />
            </div>
            <div  className='Input-Container'>
              <label htmlFor='Description-Input'>Description :</label>
              <textarea name='description' id='Description-Input'  required/>
            </div>
            
            <div className='Input-Container'>
              <label htmlFor='Todo-priorities'>Priority :</label>
              <select name='priority' id='Todo-priorities'>
                <option>Low</option>
                <option>Medium</option>
                <option>High</option>
              </select>
            </div>
            
            <br />
            <button type='submit' className='Drawer-Submit'>
              Submit
            </button>
          </form>
          
        </div>
      </Drawer>

    
    <div className='Side-Content Todos-Main-Container'>
      
      {/* <div className='Topbar'>
        <button id='Create-Todo-Btn' onClick={toggleDrawerModal}>
          <DynamicSVG SvgName="Plus-Icon"/>
          Create a Todo
        </button>
      </div> */}
      <TopNavBar OptionsMenuElements={[
        <button id='Create-Todo-Btn' onClick={toggleDrawerModal}>
          <DynamicSVG SvgName="Plus-Icon"/>
          Create a Todo
        </button>
      ]}>
        <h2 className='TopNav-Content'>{project.ProjectName}</h2>
      </TopNavBar>
        
        {/* <div className='Todo-progress-Container'>
          <div className='Todo-progress-Bar' style={{"--Value":`${State.ProgressBarVal}%`} as CSSProperties}></div>
          <span className='ProgressBar-Label'>{State.ProgressBarVal.toFixed(0)+"%"}</span>
        </div> */}
        <div className='Todos-List-Container'>
          <DragDropContext  onDragEnd={onDragEnd}>
        {State.TodosData.columnOrder.map((column) => {
          const currentCol = State.TodosData.columns[column]
          let currentTasks:ITodo[] = []
            currentCol.taskIDs.forEach((ID) => {
              State.TodosData.todos.forEach((todo) => {
                if(todo.id?.toString() == ID) currentTasks.push(todo)
              })
          })
          return (
            <Droppable key={currentCol.id} droppableId={currentCol.id}>
              {(provided, snapshot) => (
                <div className='Todos-List'>
                  <h3 className='TodosList-Title'>{currentCol.title}<span>{currentCol.taskIDs.length}</span></h3>
                  <ul className={snapshot.isDraggingOver?"DraggingOver":""} ref={provided.innerRef} {...provided.droppableProps}>
                  {currentTasks.map((task,i) => {
                    return (
                      <TodoListItem
                        key={task.id}
                        id={task.id ? task.id : 0}
                        index={i}
                        description={task.description}
                        priority={task.priority}
                        title={task.title}
                        {...listItemCallBacksObj}
                        status={task.status}
                        duration={(task.endDate? task.endDate.getTime() : 0) - (task.startDate != undefined? task.startDate.getTime():0)}
                    />
                    )
                  })}
                  {provided.placeholder}
                </ul>
              </div>
                
              )}
            </Droppable>)
        })}
          </DragDropContext>
        </div>
        
        {/* <div className='Todos-List-Container'>
          <ul className='Todos-List Pending-Todos'>
            <h3 className='TodosList-Title'>Pending</h3>
            {State.PendingTodosArr}
          </ul>
          <ul className='Todos-List Ongoing-Todos'>
            <h3 className='TodosList-Title'>Ongoing</h3>
            {State.OngoingTodosArr}
          </ul>
          <ul className='Todos-List Completed-Todos'>
            <h3 className='TodosList-Title'>Completed</h3>
            {State.CompletedTodosArr}
          </ul>
        </div> */}
      </div>
    </>
  )
}
